import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import FullPageLayout from '../_layout/FullPageLayout/full-page.layout';
import LoadingPage from '../_boilerplate/LoadingPage/loading-page.container';
import ErrorPage from '../_boilerplate/ErrorPage/error-page.container';
import { Text } from '../../_core/_ui/typography.component';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import {
  useParentSelf,
  useParentPlayerContacts,
  useParentPlayers,
} from '../../../lib/services/parent.service';
import { PARENT_HOME_ROUTE } from '../../../../_configuration';
import { isParentContactsSection } from '../../../lib/helpers/parent-links.helpers';
import { buildPlayerDetailsPaths } from '../../../lib/helpers/parent-players.helpers';
import { messages } from './parent-account.messages';
import { ParentNameCard } from './parent-name-card.component';
import { ParentVerifiedCredentials } from './parent-verified-credentials.component';
import { ParentPlayerContactsCard } from './parent-player-contacts-card.component';

export const ParentAccountPage: React.FC = () => {
  const { search } = useLocation();
  const { parent, loading, error } = useParentSelf();
  const { contacts, loading: contactsLoading } = useParentPlayerContacts();
  // Same query the dashboard uses (cache-and-network), read here only to give
  // each contact row a link into that player's details page.
  const { groups } = useParentPlayers();
  const playerDetailsPaths = useMemo(() => buildPlayerDetailsPaths(groups), [groups]);

  if (loading && !parent) return <LoadingPage />;
  if (error || !parent) return <ErrorPage />;

  return (
    <FullPageLayout
      maxWidth="640px"
      parentHeader={{ title: 'My account', backTo: PARENT_HOME_ROUTE, backLabel: 'My players' }}
    >
      <Text><IntlMsg {...messages.accountIntro} /></Text>

      <ParentNameCard parent={parent} />
      <ParentVerifiedCredentials parent={parent} />
      {/* Render once we have data; never gate on `loading` after that, so a
          background refetch can't unmount the card mid-edit (would collapse
          the open accordion). See "Apollo — mutations refresh every affected
          view" in CLAUDE.md. */}
      {(contacts.length > 0 || !contactsLoading) && (
        <ParentPlayerContactsCard
          parent={parent}
          contacts={contacts}
          defaultOpen={isParentContactsSection(search)}
          playerDetailsPaths={playerDetailsPaths}
        />
      )}
    </FullPageLayout>
  );
};
